// src/main.js - Modification pour accéder directement à /performance
import { createApp } from 'vue'
import App from './App.vue'
import { createStore } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'
import PerformanceForm from './components/PerformanceForm.vue'
import AuthComponent from './components/AuthComponent.vue'

// Importation de Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// Configuration de Vuetify avec uniquement le thème sombre moderne
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'darkModern',
    themes: {
      // Thème moderne sombre inspiré du design
      darkModern: {
        dark: true,
        colors: {
          // Couleurs principales
          primary: '#73e067',    // Vert vif comme dans le design
          secondary: '#9f94ff',  // Bleu lavande comme dans le design
          accent: '#ff9773',     // Orange comme dans le design
          
          // Couleurs fonctionnelles
          error: '#ff5252',
          warning: '#ffb74d',
          info: '#4fc3f7',
          success: '#81c784',
          
          // Couleurs de fond
          background: '#121212',  // Fond très sombre
          surface: '#1e1e1e',     // Surface légèrement plus claire
          
          // Couleurs additionnelles pour les graphiques et métriques
          'inflow': '#73e067',     // Vert pour entrées (arraché)
          'outflow': '#9f94ff',    // Bleu pour sorties (épaulé-jeté)
          'savings': '#38a877',    // Vert foncé pour épargne
          'net-change': '#ff9773'  // Orange pour variations nettes
        }
      }
    },
    display: {
      mobileBreakpoint: 'sm', // Définit clairement le breakpoint mobile
      thresholds: {
        xs: 350,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  }
})

// Création du store Vuex
const store = createStore({
  state() {
    return {
      user: null,
      isAuthenticated: false
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    }
  },
  actions: {
    loginUser({ commit }, user) {
      commit('setUser', user);
    },
    logoutUser({ commit }) {
      commit('setUser', null);
    }
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    currentUser: (state) => state.user
  }
});

// Configuration des routes
const routes = [
  { path: '/', component: AuthComponent },
  { 
    path: '/performance', 
    component: PerformanceForm,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Auto-authentification en mode développement local
const IS_DEVELOPMENT = true; // Assurez-vous que c'est true pour le développement

if (IS_DEVELOPMENT) {
  // Auto-login pour le développement
  store.dispatch('loginUser', {
    displayName: 'Mode Développement',
    email: 'dev@local.com',
    uid: 'dev-local-123'
  });
  console.log('Mode développement : authentification automatique activée');
}

// Désactiver temporairement la vérification d'authentification
router.beforeEach((to, from, next) => {
  // Toujours autoriser l'accès en mode développement
  next();
});

// Redirection automatique vers /performance au démarrage
router.afterEach((to) => {
  // Si la page est la page d'accueil, rediriger vers /performance
  if (to.path === '/' && IS_DEVELOPMENT) {
    router.push('/performance');
  }
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vuetify);
app.mount('#app');